import type { IPaymentStandard } from '@/types/payment'
import type { IProduct } from '@/types/product'
import { atom } from 'nanostores'

export const store = {
  recommendations: atom<IProduct[]>([]),
  payment: atom<IPaymentStandard | null>(null),
}

export const actions = {
  add(courses: IProduct[], payment: IPaymentStandard) {
    if (courses.length) {
      const current = store.recommendations.get()
      const exists = new Set(current.map((p) => p._id))
      const uniq = courses.filter((p) => !exists.has(p._id))
      store.recommendations.set([...current, ...uniq])
      store.payment.set(payment)
    }
  },

  getLowerPrice() {
    const courses = store.recommendations.get()
    if (!courses.length) return null

    const product = courses.sort(
      (a, b) => (b.percentage_off || 0) - (a.percentage_off || 0),
    )[0]

    return product
  },

  clear() {
    store.recommendations.set([])
  },
}
